import { render } from "./PartyProDetails.vue?vue&type=template&id=4508ab63&scoped=true&ts=true"
import script from "./PartyProDetails.vue?vue&type=script&lang=ts"
export * from "./PartyProDetails.vue?vue&type=script&lang=ts"

import "./PartyProDetails.vue?vue&type=style&index=0&id=4508ab63&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4508ab63"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QList from 'quasar/src/components/item/QList.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QSelect,QItem,QItemSection,QItemLabel,QInput,QList,QBtn,QToggle,QField});
